import { ListResponseModel, toQueryString } from ".";
import { WalletHistoryParams, WalletTransactionResponse } from "../pages/customer/wallet/models/WalletTransactionResponse";
import { apiSlice } from "../stores/base/api-slice";

const serviceBaseurl = "/charge/wallet";


const walletEndpoints = apiSlice.injectEndpoints({
	endpoints: builder => ({
		getWalletTransactions: builder.query<ListResponseModel<Array<WalletTransactionResponse>>, WalletHistoryParams>({
			query: params => ({
				url: `${serviceBaseurl}/history` + toQueryString(params),
				method: "GET",
			}),
		}),
	}),
});

export const { useLazyGetWalletTransactionsQuery } = walletEndpoints;
